import { render, staticRenderFns } from "./BarDataPlate.vue?vue&type=template&id=507f394c&scoped=true&"
import script from "./BarDataPlate.vue?vue&type=script&lang=ts&"
export * from "./BarDataPlate.vue?vue&type=script&lang=ts&"
import style0 from "./BarDataPlate.vue?vue&type=style&index=0&id=507f394c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507f394c",
  null
  
)

export default component.exports